/* eslint-disable */
import {
  Calendar,
  DateClickInfo,
  DateSelectInfo,
  DatesSetInfo,
  EventApi,
  EventDisplayInfo,
  EventDropInfo,
  EventInput,
  EventResizeDoneInfo,
  EventSegment,
  EventSourceInput
} from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/react/daygrid'
import rrulePlugin from '@fullcalendar/rrule'
import timeGridPlugin from '@fullcalendar/react/timegrid'
import listPlugin from '@fullcalendar/react/list'
import interactionPlugin from '@fullcalendar/react/interaction'
import { withObservables } from '@nozbe/watermelondb/react'
/* eslint-enable */
import './styles.scss'
import * as Styled from './styled'
import ObserveService from 'services/db/Observe'
import { dayHeaderClass } from 'utils/calendar'
import {
  AllDayContent,
  DayCellContent,
  DayHeaderContent,
  EventContent,
  getEventInstanceTimes,
  SlotLabelContent
} from './components'
import {
  CALENDAR_VIEW,
  useCalendar
} from 'components/providers/CalendarProvider'
import { AddIcon } from 'assets/icons'
import { Model } from 'types/model'
import {
  AccountDoc,
  AccountProduct,
  DocType,
  EventDoc,
  EventStatus,
  GroupDoc,
  TaskType,
  UserSettingsDoc
} from 'types/api/changes'
import dayjs, { Dayjs, ManipulateType } from 'dayjs'
import { StartEndEvent, generateStartEndBasedOnTimeWithShift } from 'utils/date'
import {
  TEMP_EVENT_CREATED_EVENT,
  TEMP_EVENTS_REMOVED_EVENT,
  addTempEventToDate,
  localEventById
} from 'services/db/Queries/Event'
import {
  localGroupById,
  provideFirstGroup
} from 'services/db/Queries/GroupQueries'
import { LocalStorageKey } from 'types/services/localStorage'
import LocalStorage from 'services/LocalStorage'
import {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
  startTransition,
  ComponentRef,
  Ref
} from 'react'
import {
  isGroupNotAvailableForEventChanges,
  isGroupOutOfTier,
  isUserActiveInGroup,
  isUserCanOperateEvents,
  isUserHaveGroupToAddEvents
} from 'utils/api/groups'
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog'
import { getProfilesForParticipants } from 'services/api/group'
import { exhaustedProduct, highestActiveTier } from 'utils/api/accounts'
import { OutOfTierDialog } from 'components/tier/OutOfTierDialog'
import { APP_COLOR } from 'utils/colors'
import Analytics, {
  BlockedFlow,
  EventProperties,
  Events
} from 'analytics/Analytics'
import Logger from 'services/Logger'
import { t } from 'i18next'
import i18n from 'i18n'
import { usePayment } from 'components/providers/PaymentProvider'
import {
  getArchivedGroups,
  getDeletedGroups,
  isGroupArchived,
  isGroupHidden
} from 'utils/api/userSettings'
import { CalendarRange } from 'types/components/calendar'
import Database from 'services/db/Database'
import { updateEventOnServer } from 'services/api/event'
import RecurrentActionDialog from 'components/dialogs/RecurrentActionDialog'
import { EventError, EventErrorType } from 'types/errors'
import {
  RECUR_SAVE_TYPE,
  parseErrorToMessage
} from 'components/popups/eventInfo/EventPopup'
import { uuid } from 'utils/uuid'
import { AxiosError } from 'axios'
import { Box, Tooltip, useTheme } from '@mui/material'
import { EventsListPopupContent } from 'components/popups/EventsListPopup'
import { EventBare as Event } from './components/Event'
import { is24meApp, isGroupcalApp } from 'utils/appType'
import {
  defaultGroupId,
  groupToProvider,
  isConvertedGroup,
  ProviderType
} from 'utils/groups'
import React from 'react'
import { useAppSettings } from 'components/providers/AppSettingsProvider'
import ListView from './ListView'
import { useCalendarSync } from 'components/providers/CalendarSyncProdivder'
import { CurrentConvertedCalendars } from 'utils/google_events'
import {
  icloudPrefix,
  outlookPrefix,
  prefixGoogleEventsGroup
} from 'utils/constants'

import '@fullcalendar/react/skeleton.css'
import '@fullcalendar/react/themes/classic/theme.css'
import '@fullcalendar/react/themes/classic/palette.css'
import FullCalendar from '@fullcalendar/react'

import themePlugin from '@fullcalendar/react/themes/classic'
import adaptivePlugin from '@fullcalendar/react-scheduler/adaptive'
import { ResyncCalendarDialog } from 'components/dialogs/ResyncGoogleDialog'
import EventContextMenu from 'components/contextMenu/EventContextMenu'
import TFloatingPopover from 'components/popovers/TFloatingPopover'
import { useAuth } from 'components/providers/AuthProvider'
import { useChatbase } from 'components/providers/ChatbaseProvider'
import { useLandlineCheck } from 'components/providers/LandlineCheckProvider'
import { useNetworkStatus } from 'hooks/useNetworkStatus'
import { useLocalStorageState } from 'hooks/usePersistState'
import { getDefaultTimezone } from 'index'
import { PERF_EVENTS } from 'PerfTest'
import { rrulestr } from 'rrule'
import { provideReferenceGroup } from 'utils/api/group_state'
import {
  isEventInstanceWithinTimePeriod,
  isEventRecurrenceInstanceValid,
  isLateInstance,
  isSomeDayInstance
} from 'utils/api/instance_state'
import { isCypress } from 'utils/cypress'
import { isInIframe } from 'utils/env'
import { eventIdForContainer, eventLengthInDays } from 'utils/event'
import { getFullCalendarEventId, mapEventsToCalendar } from 'utils/fc_mapping'
import { isTrulyEmpty, removePrefix } from 'utils/object'
import { mapRecurrency } from 'utils/recurrence'
import { isUserOutOfTierBasedOnLandline } from 'utils/tier'
import { isGuest } from 'utils/user'

import { useEventPopoverCallbacks } from './eventPopover/EventPopoverProvider'
import GalleryView from './GalleryView'
import EventGlobalsProvider from 'components/providers/EventGlobalsProvider'
import { DEFAULT_CALENDAR_CHANGED_EVENT } from 'components/popups/groupInfo/SettingsForCalendarSection'

type FullCalendarRef = ComponentRef<typeof FullCalendar>

export enum FIRST_DAYS {
  SUNDAY = 1,
  MONDAY = 2,
  SATURDAY = 7
}

// Returns true when two EventInput objects are visually equivalent.
// Reusing the same object reference prevents FullCalendar from re-processing events,
// which improves performance especially with rrule events (prevents remove→re-expand blink).
// Works for both rrule and one-time events by comparing _eventRev and core properties.
function isEventInputEquivalent(prev: EventInput, next: EventInput): boolean {
  // If revisions match, the underlying event data hasn't changed
  const prevRev = (prev as any)._eventRev
  const nextRev = (next as any)._eventRev
  if (prevRev !== undefined && nextRev !== undefined && prevRev !== nextRev) {
    return false
  }

  const prevRenderKey = (prev as any)._renderKey
  const nextRenderKey = (next as any)._renderKey
  if (
    prevRenderKey !== undefined &&
    nextRenderKey !== undefined &&
    prevRenderKey !== nextRenderKey
  ) {
    return false
  }

  const prevExdates = Array.isArray((prev as any).exdate)
    ? ((prev as any).exdate as unknown[])
    : undefined
  const nextExdates = Array.isArray((next as any).exdate)
    ? ((next as any).exdate as unknown[])
    : undefined

  if (prevExdates || nextExdates) {
    if (
      !prevExdates ||
      !nextExdates ||
      prevExdates.length !== nextExdates.length
    ) {
      return false
    }

    for (let index = 0; index < prevExdates.length; index++) {
      if (prevExdates[index] !== nextExdates[index]) {
        return false
      }
    }
  }

  // Compare key rendering properties
  return (
    prev.rrule === next.rrule &&
    prev.start === next.start &&
    prev.end === next.end &&
    prev.allDay === next.allDay &&
    prev.title === next.title &&
    prev.id === next.id &&
    prev.editable === next.editable &&
    prev.durationEditable === next.durationEditable
  )
}

interface CalendarViewProps {
  events: Model<EventDoc>[]
  groups: Model<GroupDoc>[]
  userSettings: Model<UserSettingsDoc>
  groupID: string
  group: Model<GroupDoc>
  readOnly?: boolean
  firstGroup: Model<GroupDoc>
  account: Model<AccountDoc>
  defaultView?: CalendarRange
  showOnlySelectedGroup?: boolean
  dayNameFormat?: string
  groupIds?: string[]
  embedMode: boolean
  onGuestDateRangeChange?: (dateRange: DateRange, view: CalendarRange) => void
}

interface DateRange {
  leftBound: number
  rightBound: number
}

interface DropEventData {
  newEvent: EventApi
  oldEvent: Model<EventDoc> | EventDoc
  oldAllDay: boolean
  oldStart: number
  oldEnd: number
  oldTimeZone: string
  newStart: number
  newEnd: number
}

function shouldIncludeEventInVisibleArea(
  event: EventDoc,
  visibleAreaStart: Dayjs,
  visibleAreaEnd: Dayjs
) {
  if (isSomeDayInstance(event) || isLateInstance(event)) return true

  if (isEventRecurrenceInstanceValid(event, visibleAreaStart)) {
    const eventStart = Number(event.StartDate)
    return (
      !Number.isFinite(eventStart) ||
      eventStart <= visibleAreaEnd.endOf('day').unix()
    )
  }

  return isEventInstanceWithinTimePeriod(
    event,
    visibleAreaStart,
    visibleAreaEnd
  )
}

function isBlankLocalTempEvent(event?: EventDoc | Model<EventDoc>) {
  return event?._id === ''
}

function CalendarView(props: CalendarViewProps) {
  const calendarSync = useCalendarSync()
  const theme = useTheme()
  const [showUserRemovedDialog, setShowUserRemovedDialog] = useState(false)
  const calendar = useCalendar()
  const [userCannotAddEvents, setUserCanAddEvents] = useState(false)
  const [showOutOfTierDialog, onShowOutOfTierDialog] = useState(false)
  const [dateRange, onDateRange] = useState<DateRange>()

  const showCanAddEventsDialog = useCallback(() => {
    setUserCanAddEvents(true)
  }, [])

  const activeTier = useMemo(
    () => highestActiveTier(props.account),
    [props.account?._rev]
  )

  const isOutOfTier = useMemo(
    () => isGroupOutOfTier(activeTier, props.group, props.account),
    [activeTier, props.group, props.account?._rev]
  )

  const [showCalendarSync, onShowCalendarSync] = useState(false)

  const auth = useAuth()

  const showCanOperateEventsIfNeeded = useCallback(() => {
    if (
      props.group &&
      !isUserCanOperateEvents(
        props.group,
        LocalStorage.get(LocalStorageKey.USER_ID)!
      )
    ) {
      ;(calendar.ref as any).current?.getApi().unselect()
      showCanAddEventsDialog()
      return true
    }

    return false
  }, [props.group, calendar.ref])

  const showSyncIfNeeded = useCallback(() => {
    if (props.group?.SyncProblem === '1') {
      ;(calendar.ref as any).current?.getApi().unselect()

      onShowCalendarSync(true)
      return true
    }

    return false
  }, [props.group?.SyncProblem, calendar.ref])

  const hideCanAddEventsDialog = useCallback(() => {
    setUserCanAddEvents(false)
  }, [])

  const hideUserRemovedDialog = useCallback(() => {
    setShowUserRemovedDialog(false)
  }, [])

  const showUserRemoved = useCallback(() => {
    setShowUserRemovedDialog(true)
  }, [])

  const userRemoved =
    !isUserActiveInGroup(
      props.group,
      LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
    ) && (LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? '').length > 0

  const onDatesSet = useCallback(
    (datesSetArg: DatesSetInfo) => {
      Logger.blue('DatesSet: ', datesSetArg)
      const nowDayJs = dayjs()
      let offset = new Date().getTimezoneOffset()
      if (offset > 0) {
        //
      } else if (offset < 0) {
        offset = Math.abs(offset)
      } else {
        //
      }
      const startDayJs = dayjs(datesSetArg.start.valueOf()).add(
        offset,
        'minute'
      )
      const endDayJs = dayjs(datesSetArg.end.valueOf())
        .add(offset, 'minute')
        .add(-1, 'second')

      const centerDayJs = dayjs((startDayJs.valueOf() + endDayJs.valueOf()) / 2)

      calendar.onSetFromTo(startDayJs.toISOString(), endDayJs.toISOString())
      ;(datesSetArg.view as any).dateEnv.defaultSeparator = '\n'

      let timePeriod: ManipulateType = 'day'

      if (
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) ===
          CalendarRange.MONTH ||
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) === CalendarRange.CARDS
      ) {
        timePeriod = 'month'
      } else if (
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) ===
          CalendarRange.WEEK ||
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) ===
          CalendarRange.LISTWEEK
      ) {
        timePeriod = 'week'
      }

      const shouldManipulate =
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) !==
          CalendarRange.LISTWEEK &&
        LocalStorage.get(LocalStorageKey.CALENDAR_VIEW) !==
          CalendarRange.LISTDAY

      const oldFrom = LocalStorage.get(LocalStorageKey.VISIBLE_FROM)
      const oldTo = LocalStorage.get(LocalStorageKey.VISIBLE_TO)

      LocalStorage.set(
        LocalStorageKey.VISIBLE_FROM,
        startDayJs.subtract(shouldManipulate ? 1 : 0, timePeriod).toISOString()
      )
      LocalStorage.set(
        LocalStorageKey.VISIBLE_TO,
        endDayJs.add(shouldManipulate ? 1 : 0, timePeriod).toISOString()
      )

      Logger.debug('old from/to', oldFrom, oldTo)
      Logger.debug(
        'set visible from/to',
        LocalStorage.get(LocalStorageKey.VISIBLE_FROM),
        LocalStorage.get(LocalStorageKey.VISIBLE_TO)
      )
      Logger.debug(
        'First get changes',
        auth.firstGetChangesFinished,
        LocalStorage.get(LocalStorageKey.USER_ID)
      )

      if (
        (oldFrom !== LocalStorage.get(LocalStorageKey.VISIBLE_FROM) ||
          oldTo !== LocalStorage.get(LocalStorageKey.VISIBLE_TO)) &&
        auth.firstGetChangesFinished &&
        LocalStorage.get(LocalStorageKey.USER_ID)
      ) {
        if (syncDebounceRef.current) clearTimeout(syncDebounceRef.current)
        syncDebounceRef.current = setTimeout(() => {
          calendarSync.sync()
        }, 400)
      }

      onDateRange({
        leftBound: startDayJs.unix(),
        rightBound: endDayJs.unix()
      })

      if (
        datesSetArg.view.type === 'dayGridMonth' ||
        datesSetArg.view.type === 'galleryMonth'
      ) {
        if (nowDayJs.isAfter(startDayJs) && nowDayJs.isBefore(endDayJs)) {
          LocalStorage.set(LocalStorageKey.VISIBLE_DATE, nowDayJs.valueOf())
        } else if (centerDayJs.month() != nowDayJs.month()) {
          LocalStorage.set(
            LocalStorageKey.VISIBLE_DATE,
            startDayJs
              .add(centerDayJs.month() != startDayJs.month() ? 1 : 0, 'week')
              .valueOf()
          )
        } else {
          if (startDayJs.month() === nowDayJs.month()) {
            LocalStorage.set(LocalStorageKey.VISIBLE_DATE, startDayJs.valueOf())
          } else {
            LocalStorage.set(
              LocalStorageKey.VISIBLE_DATE,
              startDayJs.add(1, 'week').valueOf()
            )
          }
        }
      } else {
        if (nowDayJs.isAfter(startDayJs) && nowDayJs.isBefore(endDayJs)) {
          LocalStorage.set(LocalStorageKey.VISIBLE_DATE, nowDayJs.valueOf())
        } else {
          LocalStorage.set(
            LocalStorageKey.VISIBLE_DATE,
            startDayJs
              .set('hour', nowDayJs.hour())
              .set('minute', 0)
              .set('second', 0)
              .add(1, 'hour')
              .valueOf()
          )
        }
      }
    },
    [calendar, auth.firstGetChangesFinished, calendarSync, onDateRange]
  )

  //update profiles each time group presented
  useEffect(() => {
    if (
      props.group &&
      props.group.Participants &&
      LocalStorage.get(LocalStorageKey.USER_ID)
    )
      getProfilesForParticipants(Object.keys(props.group.Participants || {}))
  }, [props.groupID])

  useEffect(() => {
    if (!isGuest() || !dateRange || !props.onGuestDateRangeChange) return
    props.onGuestDateRangeChange(dateRange, calendar.view)
  }, [dateRange, calendar.view, props.onGuestDateRangeChange])

  const queryParams = new URLSearchParams(location.search)
  const predefinedView = queryParams.get('view') as CalendarRange
  const oneDayAtATime = queryParams.get('oneDateAtTime') === '1'

  useEffect(() => {
    if (oneDayAtATime) {
      calendar.onView(CalendarRange.LISTDAY)
    }
  }, [])

  const [updateEventError, setUpdateEventError] = useState<string | undefined>()

  const [droppedEventData, onDroppedEventData] = useState<
    DropEventData | undefined
  >(undefined)

  async function updateEventData(
    newEvent: EventApi,
    oldEventModel: EventApi,
    publicId: string
  ) {
    const oldEvent =
      eventModelMapRef.current.get(oldEventModel.id) ??
      eventModelMapRef.current.get(publicId)

    if (!oldEvent) {
      Logger.red('updateEventData: old event not found for', oldEventModel.id)
      return
    }
    LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)

    const showingEvent = LocalStorage.get(LocalStorageKey.VISIBLE_EVENT)

    Logger.pink('dropped', newEvent, oldEventModel)
    Logger.pink(
      'will set',
      LocalStorage.get(LocalStorageKey.VISIBLE_EVENT) !== null
    )

    if ((newEvent.allDay ? '1' : '0') !== oldEvent.AllDay) {
      ;(calendar.ref as any).current?.getApi().getEventById(publicId)?.remove()
    }

    if (oldEvent.someday === '1') {
      LocalStorage.set(
        LocalStorageKey.SOMEDAY_DATE,
        (newEvent.start?.valueOf() ?? 0) / 1000
      )
      LocalStorage.set(
        LocalStorageKey.SOMEDAY_ALL_DAY,
        newEvent.allDay ? '1' : '0'
      )
      return
    }

    if (showingEvent != null) {
      //only in case event was opened previously
      if (showingEvent.includes(oldEvent._id)) {
        LocalStorage.set(
          LocalStorageKey.VISIBLE_EVENT,
          `${oldEvent._id}${newEvent?.start?.valueOf()}`
        )
      } else {
        LocalStorage.remove(LocalStorageKey.VISIBLE_EVENT)
      }
    }
    const oldLocal = await localEventById(oldEvent._id)
    if (!oldLocal) {
      console.log('not found')
      return
    }
    const oldStart = (oldEventModel.start?.valueOf() ?? 0).toString()
    const oldEnd = (oldEventModel.end?.valueOf() ?? 0).toString()

    const newAlldayStart = dayjs
      .utc(dayjs(newEvent.startStr))
      .add(1, 'day')
      .startOf('day')
    const newAlldayEnd = newEvent.endStr
      ? dayjs.utc(dayjs(newEvent.endStr)).startOf('day')
      : newAlldayStart

    const start = newEvent.allDay
      ? newAlldayStart.unix().toString()
      : `${(newEvent.start?.valueOf() ?? 0) / 1000}`
    const end = newEvent.allDay
      ? newAlldayEnd.unix().toString()
      : (
          (newEvent.end ?? newEvent.start ?? new Date())?.valueOf() / 1000 +
          (newEvent.end ? 0 : 60 * 60)
        ).toString()

    function updateLocalEvent() {
      return Database.write(async () => {
        return oldLocal.update((local) => {
          if (newEvent.start) {
            if (local.syncStatus != 'deleted') {
              local.StartDate = start
              local.EndDate = end
              local.LastUpdate = dayjs().unix().toString()
              local.AllDay = newEvent.allDay ? '1' : '0'
              local.TimeZoneNameID = newEvent.allDay
                ? 'UTC'
                : oldEventModel.allDay
                  ? getDefaultTimezone()
                  : (oldLocal.TimeZoneNameID ?? getDefaultTimezone())
            }
          }
        })
      })
    }

    if (oldLocal.syncStatus === 'deleted') return

    if (oldEvent && !oldEvent.Recurrence?.Unit) {
      const updatedLocal = await updateLocalEvent()

      try {
        if (
          updatedLocal._id.length > 0 ||
          (updatedLocal.local_id?.length ?? 0) > 0
        ) {
          ;(calendar.ref as any).current?.getApi().scrollToTime(
            dayjs(newEvent.start)
              .tz(
                (oldEvent.TimeZoneNameID?.length ?? 0) > 0
                  ? oldEvent.TimeZoneNameID
                  : getDefaultTimezone()
              )
              .format('HH:mm:ss')
          )
          await updateEventOnServer(
            updatedLocal,
            Database.toServerObject<EventDoc>(updatedLocal) as EventDoc
          )
        }
      } catch (e) {
        if (e instanceof AxiosError) {
          if (e.response?.status === 400) {
            console.error(e)
          } else if (e.response?.status === 403) {
            setUpdateEventError(parseErrorToMessage(e, updatedLocal._id))
            Database.write(async () => {
              updatedLocal.update((local) => {
                local.StartDate = oldStart
                local.EndDate = oldEnd
              })
            }).then(() => {
              ;(calendar.ref as any).current?.getApi().scrollToTime(
                dayjs(Number(oldStart) * 1000)
                  .tz(
                    isTrulyEmpty(oldEvent.TimeZoneNameID)
                      ? getDefaultTimezone()
                      : oldEvent.TimeZoneNameID
                  )
                  .format('HH:mm:ss')
              )
            })
          }
        }
      }
    } else {
      const data: DropEventData = {
        newEvent,
        oldEvent,
        oldAllDay: oldEvent.AllDay === '1',
        oldStart: Number(oldStart),
        oldEnd: Number(oldEnd),
        oldTimeZone: isTrulyEmpty(oldEvent.TimeZoneNameID)
          ? getDefaultTimezone()
          : oldEvent.TimeZoneNameID,
        newStart: Number(start),
        newEnd: Number(end)
      }
      onDroppedEventData(data)
    }
  }

  const [cachedRevert, setCachedRevert] = useState<() => void>()
  const [showRecurrenceDialog, setShowRecurrenceDialog] = useState(false)
  const handleSaveRecurringEvent = async (type: RECUR_SAVE_TYPE) => {
    Logger.pink('handle on calendar type; data', type, droppedEventData)

    if (droppedEventData) {
      const newStart = dayjs(droppedEventData.newEvent.start)
      const newEnd = droppedEventData.newEvent.end
        ? dayjs(droppedEventData.newEvent.end)
        : newStart.add(1, 'hour')
      const isAllDay = droppedEventData.newEvent.allDay
      const oldData = Database.toServerObject<EventDoc>(
        droppedEventData.oldEvent
      )

      const originalEvent = await localEventById(
        droppedEventData.oldEvent._id ?? ''
      )

      const newValues: EventDoc = {
        ...oldData,
        id: undefined,
        StartDate: `${droppedEventData.newStart}`,
        EndDate: `${droppedEventData.newEnd}`,
        AllDay: isAllDay ? '1' : '0',
        TimeZoneNameID:
          droppedEventData.oldEvent.AllDay === '1'
            ? getDefaultTimezone()
            : droppedEventData.oldEvent.TimeZoneNameID,
        SupplementaryGroupsIDs: oldData.SupplementaryGroupsIDs ?? []
      }

      calendarSync
        .syncEventWithThirdParty(
          Number(droppedEventData.oldStart),
          Number(droppedEventData.oldEnd),
          newValues,
          originalEvent,
          false,
          true,
          type,
          false
        )
        .then(() => {
          onDroppedEventData(undefined)
        })
        .catch((e) => {
          Logger.red('syncEventWithThirdParty error', e)

          // Revert the event to its original state in the database
          Database.write(async () => {
            if (originalEvent && typeof originalEvent.update === 'function') {
              originalEvent.update((local) => {
                local.StartDate = `${droppedEventData.oldStart / 1000}`
                local.EndDate = `${droppedEventData.oldEnd / 1000}`
                local.AllDay = droppedEventData.oldAllDay ? '1' : '0'
                local.TimeZoneNameID = droppedEventData.oldTimeZone
              })
            }
          }).then(() => {
            // Clear the dropped event data to reset the UI
            onDroppedEventData(undefined)

            // Force FullCalendar to refetch events and re-render
            ;(calendar.ref as any).current?.getApi()?.refetchEvents()

            // Optionally show an error message
            setUpdateEventError(
              e instanceof AxiosError
                ? parseErrorToMessage(e, originalEvent?._id ?? '')
                : t('failedToUpdateEvent')
            )
          })
        })
    }

    setShowRecurrenceDialog(false)
  }

  useEffect(() => {
    handleSaveRecurringEvent(RECUR_SAVE_TYPE.THIS)
  }, [droppedEventData])

  const dropCallback = useCallback(
    (arg: EventDropInfo) => {
      if (showSyncIfNeeded()) {
        return
      }
      setCachedRevert(() => arg.revert)
      updateEventData(arg.event, arg.oldEvent, arg.oldEvent._def.publicId)
    },
    [showSyncIfNeeded]
  )

  const resizeCallback = useCallback(
    (arg: EventResizeDoneInfo) => {
      if (showSyncIfNeeded()) {
        return
      }

      updateEventData(arg.event, arg.oldEvent, arg.oldEvent._def.publicId)
    },
    [showSyncIfNeeded]
  )

  const handleCloseRecurringSave = () => {
    setShowRecurrenceDialog(false)
  }

  const [eventsForCalendar, setEventsForCalendar] = useState<
    | {
        fcEvents: EventInput[]
        filteredEvents: EventDoc[]
      }
    | undefined
  >(undefined)

  // Keep full event objects outside FullCalendar to reduce per-event payload size.
  const eventModelMapRef = useRef<Map<string, EventDoc | Model<EventDoc>>>(
    new Map()
  )

  // Stable getter: reads from the always-current ref without changing its own reference.
  // Passing this to TfmFullCalendarMemo instead of the map prevents re-renders of
  // TfmFullCalendarMemo (and all its useCallback deps) on every DB event update.
  const getEventModel = useCallback(
    (id: string) => eventModelMapRef.current.get(id),
    []
  )

  // Tracks previous rrule EventInput objects by id so we can reuse stable references.
  const prevFcEventsMapRef = useRef<Map<string, EventInput>>(new Map())

  // Maps expected real FC event id -> temp EventApi added via calendarApi.addEvent()
  const pendingTempFcEventsRef = useRef<
    Map<string, { eventApi: EventApi; tempId: string }>
  >(new Map())

  const suppressBlankTempEventsRef = useRef(false)

  // Cache group data across renders to avoid re-fetching on date switches
  const groupDataCacheRef = useRef<Map<string, GroupDoc | null>>(new Map())

  // Debounce timer for calendarSync.sync() to avoid firing on every navigation step
  const syncDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const isListOrGalleryView =
    calendar.view === CalendarRange.LISTWEEK ||
    calendar.view === CalendarRange.LISTDAY ||
    calendar.view === CalendarRange.CARDS

  const [cachedConvertedCalendars] = useLocalStorageState<any[]>(
    LocalStorageKey.CACHED_CONVERTED_CALENDARS,
    []
  )

  // Memoize filtered events computation for better performance
  const filteredEventsResult = useMemo(() => {
    const visibleAreaStart = dayjs(
      LocalStorage.get(LocalStorageKey.VISIBLE_FROM) ?? ''
    )
    const visibleAreaEnd = dayjs(
      LocalStorage.get(LocalStorageKey.VISIBLE_TO) ?? ''
    )
    const hasVisibleArea =
      visibleAreaStart.isValid() && visibleAreaEnd.isValid()
    const currentGroup = LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? ''
    const userId = LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
    const archivedGroups = getArchivedGroups(props.userSettings)
    const deletedGroups = getDeletedGroups(props.userSettings)
    const groupsSettings = props.userSettings?.GroupsSettings
    const hasGroupIds = (props.groupIds?.length ?? 0) > 0

    // Optimize: Convert arrays to Sets for O(1) lookups instead of O(n)
    const archivedGroupsSet = new Set(archivedGroups)
    const deletedGroupsSet = new Set(deletedGroups)
    const groupIdsSet = props.groupIds ? new Set(props.groupIds) : undefined
    let skippedByVisibleArea = 0

    const result = props.events.filter((event) => {
      const isAllSupplementaryArchived = (
        event.SupplementaryGroupsIDs ?? [event.GroupID ?? '']
      )?.every((id) => archivedGroupsSet.has(id))

      const isShowingOnlyMyEventsInGroup =
        groupsSettings?.[event.GroupID ?? '']?.ShoWOnlyEventsIOwn === '1'

      const cachedCalendarSyncable = cachedConvertedCalendars.find(
        (cal) =>
          cal.localId === (event.GroupID ?? '') && cal.id === event.ThirdPartyID
      )?.syncable
      const settingsConvertedCalendars =
        props.userSettings?.GroupsSettings?.[event.GroupID ?? '']
          ?.ConvertedCalendars
      const settingsCalendarSyncable = settingsConvertedCalendars?.find(
        (cal) => cal.id === event.ThirdPartyID
      )?.syncable

      const calendarHidden =
        (cachedCalendarSyncable ?? settingsCalendarSyncable) === false

      if (calendarHidden) return false

      // Archived groups check
      if (
        ((archivedGroupsSet.has(event.GroupID ?? '') &&
          isAllSupplementaryArchived) ||
          deletedGroupsSet.has(event.GroupID ?? '')) &&
        event.GroupID !== currentGroup
      )
        return false

      // Status check
      if (
        String(event.Status) === EventStatus.DELETED ||
        String(event.Status) === EventStatus.REMOVED
      )
        return false

      // Visible-area check: keep recurring/late/someday semantics, but drop
      // one-time events that cannot appear in the current buffered range.
      if (
        hasVisibleArea &&
        !shouldIncludeEventInVisibleArea(
          event,
          visibleAreaStart,
          visibleAreaEnd
        )
      ) {
        skippedByVisibleArea++
        return false
      }

      const suppGroupStates = []

      for (const groupId of event.SupplementaryGroupsIDs ?? []) {
        const groupState = isGroupHidden(props.userSettings, groupId)
        suppGroupStates.push(
          groupState || isGroupArchived(props.userSettings, groupId)
        )
      }

      const isAllHiddenOnAllCalendars = suppGroupStates.every(
        (state) => state === true
      )

      // Group visibility check
      if (
        currentGroup !== event.GroupID &&
        isGroupHidden(props.userSettings, event.GroupID ?? '') &&
        isAllHiddenOnAllCalendars &&
        !isInIframe()
      ) {
        return false
      }

      // Selected group check
      if (props.showOnlySelectedGroup) {
        if (
          event.GroupID !== props.groupID &&
          !hasGroupIds &&
          !props.readOnly
        ) {
          return false
        } else if (hasGroupIds) {
          if (!groupIdsSet?.has(event.GroupID ?? '')) {
            return false
          } else return true
        }
      }

      // LocalStorage group check
      const selectedGroup = currentGroup

      if (!isTrulyEmpty(selectedGroup) && !hasGroupIds) {
        const groupSetting = groupsSettings?.[selectedGroup ?? '']
        if (
          groupSetting?.ShoWEventsFromOtherGroups === '0' ||
          props.embedMode
        ) {
          if (
            event.GroupID !== selectedGroup &&
            event.SupplementaryGroupsIDs?.find(
              (groupid) => groupid === selectedGroup
            ) === undefined
          ) {
            return false
          }
        }
      }

      if (isShowingOnlyMyEventsInGroup && event.OwnerID !== userId) return false

      if (hasGroupIds) {
        // meaning we want to show only specific groups
        if (!groupIdsSet?.has(event.GroupID ?? '')) {
          return false
        }
      }

      return true
    })

    return { events: result, skippedByVisibleArea }
  }, [
    props.events,
    props.userSettings?._rev,
    cachedConvertedCalendars,
    props.showOnlySelectedGroup,
    props.groupID,
    props.groupIds,
    props.readOnly,
    props.embedMode,
    dateRange?.leftBound,
    dateRange?.rightBound
  ])

  const filteredEvents = filteredEventsResult.events

  useEffect(() => {
    Logger.debug(
      `[PERF] filterEvents: ${props.events.length} -> ${filteredEvents.length} (${filteredEventsResult.skippedByVisibleArea} outside visible area)`
    )
  }, [
    filteredEvents,
    filteredEventsResult.skippedByVisibleArea,
    props.events.length
  ])

  const isOnline = useNetworkStatus()

  useEffect(() => {
    let cancelled = false
    const currentGroup = LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? ''
    const persistentGroupCache = groupDataCacheRef.current

    // Extract unique group IDs from filtered events
    const uniqueGroupIds = [
      ...new Set(filteredEvents.map((e) => e.GroupID ?? ''))
    ]

    // Separate cached vs uncached groups
    const cachedGroupIds = uniqueGroupIds.filter((id) =>
      persistentGroupCache.has(id)
    )
    const uncachedGroupIds = uniqueGroupIds.filter(
      (id) => !persistentGroupCache.has(id)
    )

    // Fetch only uncached groups in parallel
    if (uncachedGroupIds.length > 0) {
      Promise.all(
        uncachedGroupIds.map((groupId) => {
          // Find first event with this groupId to pass to provideReferenceGroup
          const sampleEvent = filteredEvents.find((e) => e.GroupID === groupId)
          if (!sampleEvent) return Promise.resolve(null)

          return provideReferenceGroup(
            sampleEvent,
            props.userSettings,
            currentGroup,
            LocalStorage.get(LocalStorageKey.USER_ID) ?? ''
          )
            .then((group) => localGroupById(group ?? ''))
            .then((groupData) => {
              persistentGroupCache.set(groupId, groupData)
              return groupData
            })
        })
      ).then(() => {
        if (cancelled) return

        assignGroupsAndContinue()
      })
    } else {
      assignGroupsAndContinue()
    }

    function assignGroupsAndContinue() {
      // Build a map of group references instead of mutating event models
      const referenceGroupMap = new Map<string, GroupDoc | null>()
      filteredEvents.forEach((event) => {
        const groupId = event.GroupID ?? ''
        if (!referenceGroupMap.has(groupId)) {
          const groupData = persistentGroupCache.get(groupId)
          if (groupData) {
            referenceGroupMap.set(groupId, {
              ...Database.toServerObject(groupData)
            } as GroupDoc)
          } else {
            referenceGroupMap.set(groupId, null)
          }
        }
      })

      const eventsToMap = suppressBlankTempEventsRef.current
        ? filteredEvents.filter((event) => !isBlankLocalTempEvent(event))
        : filteredEvents

      const mapStartTime = performance.now()
      const fullEventModelMap = new Map<string, EventDoc | Model<EventDoc>>()
      const newFcEvents = mapEventsToCalendar(
        eventsToMap,
        props.groups,
        props.account,
        getDefaultTimezone(),
        isGuest(),
        LocalStorage.get(LocalStorageKey.SOMEDAY_DATE) ?? '',
        LocalStorage.get(LocalStorageKey.SOMEDAY_ALL_DAY) ?? '',
        LocalStorage.get(LocalStorageKey.USER_ID) ?? '',
        LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? '',
        referenceGroupMap,
        fullEventModelMap
      )
      const mapEndTime = performance.now()
      Logger.debug(
        `[PERF] mapEventsToCalendar: ${(mapEndTime - mapStartTime).toFixed(2)}ms for ${eventsToMap.length} events`
      )

      // Reuse previous EventInput references for events whose content hasn't changed.
      // FullCalendar's rrule plugin uses object reference equality to decide whether
      // to re-expand a recurrence rule. Extended to all events for better performance.
      const prevMap = prevFcEventsMapRef.current
      let stabilizationHits = 0
      const stabilizationStart = performance.now()
      const stabilizedFcEvents = newFcEvents.map((newEvent) => {
        const prev = prevMap.get(newEvent.id as string)
        if (prev && isEventInputEquivalent(prev, newEvent)) {
          stabilizationHits++
          return prev
        }
        return newEvent
      })
      prevFcEventsMapRef.current = new Map(
        stabilizedFcEvents.map((e) => [e.id as string, e])
      )
      eventModelMapRef.current = fullEventModelMap

      startTransition(() => {
        setEventsForCalendar({
          fcEvents: stabilizedFcEvents,
          filteredEvents: eventsToMap
        })
      })
    }

    return () => {
      cancelled = true
    }
  }, [
    filteredEvents,
    props.groups,
    props.account,
    props.userSettings,
    isOnline
  ])

  /**
   * Immediately adds a temporary event to FullCalendar via the imperative API so
   * the user sees it right away, before the WatermelonDB pipeline completes.
   * Returns the FC EventApi so it can be removed once the real event lands.
   */
  const addTempFcEvent = useCallback(
    (startTime: number, endTime: number, allDay: boolean) => {
      suppressBlankTempEventsRef.current = false

      if (isListOrGalleryView) {
        return undefined
      }

      const eventColor = ''

      const calendarApi = (calendar.ref as any).current?.getApi()
      if (!calendarApi) return undefined
      const startDate = allDay
        ? dayjs.utc(startTime * 1000).format('YYYY-MM-DD')
        : dayjs(startTime * 1000)
            .tz(getDefaultTimezone())
            .toDate()
      const endDate = allDay
        ? dayjs.utc(endTime * 1000).format('YYYY-MM-DD')
        : dayjs(endTime * 1000)
            .tz(getDefaultTimezone())
            .toDate()
      return calendarApi.addEvent({
        id: `fc-temp-${uuid()}`,
        title: '',
        color: eventColor,
        start: startDate,
        end: endDate,
        allDay,
        editable: false,
        durationEditable: false
      })
    },
    [calendar.ref, isListOrGalleryView]
  )

  const removeTempFcEventById = useCallback(
    (tempId?: string) => {
      if (!tempId) return

      const calendarApi = (calendar.ref as any).current?.getApi()
      calendarApi?.getEventById(tempId)?.remove()
    },
    [calendar.ref]
  )

  const removePendingTempFcEvents = useCallback(() => {
    suppressBlankTempEventsRef.current = true

    const calendarApi = (calendar.ref as any).current?.getApi()
    const tempModelIds = new Set<string>()
    const removableEventIds = new Set<string>()

    eventModelMapRef.current.forEach((event, id) => {
      if (isBlankLocalTempEvent(event)) {
        tempModelIds.add(id)
      }
    })

    pendingTempFcEventsRef.current.forEach((tempEntry) => {
      tempModelIds.add(tempEntry.tempId)
      removableEventIds.add(tempEntry.tempId)
    })
    pendingTempFcEventsRef.current.clear()

    calendarApi?.getEvents().forEach((eventApi: EventApi) => {
      const eventId = String(eventApi.id ?? '')
      if (eventId.startsWith('fc-temp-') || tempModelIds.has(eventId)) {
        removableEventIds.add(eventId)
      }
    })

    removableEventIds.forEach((eventId) => {
      calendarApi?.getEventById(eventId)?.remove()
    })

    eventModelMapRef.current.forEach((event, id) => {
      if (tempModelIds.has(id) || isBlankLocalTempEvent(event)) {
        eventModelMapRef.current.delete(id)
      }
    })
    prevFcEventsMapRef.current.forEach((_event, id) => {
      if (tempModelIds.has(id) || id.startsWith('fc-temp-')) {
        prevFcEventsMapRef.current.delete(id)
      }
    })

    setEventsForCalendar((previous) => {
      if (!previous) return previous

      const fcEvents = previous.fcEvents.filter((event) => {
        const eventId = String(event.id ?? '')
        const eventModel = eventModelMapRef.current.get(eventId)

        return (
          !eventId.startsWith('fc-temp-') &&
          !tempModelIds.has(eventId) &&
          !isBlankLocalTempEvent(eventModel)
        )
      })
      const filteredCalendarEvents = previous.filteredEvents.filter(
        (event) => !isBlankLocalTempEvent(event)
      )

      if (
        fcEvents.length === previous.fcEvents.length &&
        filteredCalendarEvents.length === previous.filteredEvents.length
      ) {
        return previous
      }

      return {
        fcEvents,
        filteredEvents: filteredCalendarEvents
      }
    })
  }, [calendar.ref])

  const allowPendingTempFcEvents = useCallback(() => {
    suppressBlankTempEventsRef.current = false
  }, [])

  useEffect(() => {
    window.addEventListener(TEMP_EVENT_CREATED_EVENT, allowPendingTempFcEvents)
    window.addEventListener(
      TEMP_EVENTS_REMOVED_EVENT,
      removePendingTempFcEvents
    )

    return () => {
      window.removeEventListener(
        TEMP_EVENT_CREATED_EVENT,
        allowPendingTempFcEvents
      )
      window.removeEventListener(
        TEMP_EVENTS_REMOVED_EVENT,
        removePendingTempFcEvents
      )
    }
  }, [allowPendingTempFcEvents, removePendingTempFcEvents])

  const addMappedTempFcEvent = useCallback(
    (createdEventModel: Model<EventDoc>, existingTempEvent?: EventApi) => {
      suppressBlankTempEventsRef.current = false

      if (isListOrGalleryView) {
        return undefined
      }

      const calendarApi = (calendar.ref as any).current?.getApi()
      if (!calendarApi) return undefined

      const createdEvent = Database.toServerObject<EventDoc>(
        createdEventModel
      ) as EventDoc

      const fullEventModelMap = new Map<string, EventDoc | Model<EventDoc>>()
      const referenceGroupMap = new Map<string, GroupDoc | null>()
      const createdGroup = props.groups.find(
        (group) => group._id === createdEvent.GroupID
      )

      referenceGroupMap.set(
        createdEvent.GroupID ?? '',
        createdGroup
          ? ((Database.toServerObject(createdGroup) as GroupDoc) ?? null)
          : null
      )

      const mappedEvents = mapEventsToCalendar(
        [createdEvent],
        props.groups,
        props.account,
        getDefaultTimezone(),
        isGuest(),
        LocalStorage.get(LocalStorageKey.SOMEDAY_DATE) ?? '',
        LocalStorage.get(LocalStorageKey.SOMEDAY_ALL_DAY) ?? '',
        LocalStorage.get(LocalStorageKey.USER_ID) ?? '',
        LocalStorage.get(LocalStorageKey.SELECTED_GROUP) ?? '',
        referenceGroupMap,
        fullEventModelMap
      )

      const mapped = mappedEvents[0]
      if (!mapped) return undefined

      if (existingTempEvent) {
        const originalTempId = String(existingTempEvent.id)

        existingTempEvent.setProp('title', String(mapped.title ?? ''))
        existingTempEvent.setProp('editable', Boolean(mapped.editable))
        existingTempEvent.setProp(
          'durationEditable',
          Boolean(mapped.durationEditable)
        )
        existingTempEvent.setDates(mapped.start as any, mapped.end as any, {
          allDay: Boolean(mapped.allDay)
        })

        eventModelMapRef.current.set(originalTempId, createdEventModel)

        return {
          eventApi: existingTempEvent,
          tempId: originalTempId
        }
      }

      const tempId = `fc-temp-${uuid()}`
      const tempEventApi = calendarApi.addEvent({
        ...mapped,
        id: tempId
      })

      eventModelMapRef.current.set(tempId, createdEventModel)

      return {
        eventApi: tempEventApi as EventApi,
        tempId
      }
    },
    [calendar.ref, props.groups, props.account, isListOrGalleryView]
  )

  const dateSelect = useCallback(
    (arg: DateSelectInfo) => {
      Logger.pink('FC:DateSelect', arg)

      if (isCreatingTempEventRef.current) {
        Logger.orange('DateSelect: create already in progress, skip')
        return
      }

      if (showSyncIfNeeded()) {
        return
      }

      if (showCanOperateEventsIfNeeded()) {
        return
      }

      let start = dayjs(arg.startStr)
      let end = dayjs(arg.endStr)

      // check that length bigger than 1 day
      if (
        end.diff(start, 'day') === 1 &&
        calendar.view === CalendarRange.MONTH
      ) {
        return
      }

      if (end.diff(start, 'minute') === 15) {
        LocalStorage.set(LocalStorageKey.IGNORE_EMPTY_CLICK, '1')
      }

      if (arg.allDay) {
        start = dayjs.utc(arg.startStr).startOf('day')
        end = dayjs.utc(arg.endStr).startOf('day')
      }

      isCreatingTempEventRef.current = true
      const tempFcEvent = addTempFcEvent(start.unix(), end.unix(), arg.allDay)

      addEventToDate(
        EventProperties.EVENT_FROM_SCREEN,
        props.group?._id,
        start.unix(),
        end.unix(),
        arg.allDay,
        props.userSettings
      )
        .then((created) => {
          if (created) {
            const realFcId = getFullCalendarEventId(created)

            const mappedTemp = addMappedTempFcEvent(created, tempFcEvent)

            if (mappedTemp) {
              pendingTempFcEventsRef.current.set(realFcId, mappedTemp)
            } else if (tempFcEvent) {
              pendingTempFcEventsRef.current.set(realFcId, {
                eventApi: tempFcEvent,
                tempId: String(tempFcEvent.id)
              })
            }
          } else {
            removeTempFcEventById(tempFcEvent?.id)
          }
          Logger.orange('added', created)
          ;(calendar.ref as any).current?.getApi().unselect()
        })
        .catch((e) => {
          Logger.red('addEventToDate error', e)
          if (e instanceof EventError) {
            if (e.type === EventErrorType.NO_SYNCABLE_CALENDAR) {
              setUpdateEventError(t('personalNoCalendars'))
            }
          }

          removeTempFcEventById(tempFcEvent?.id)
          Logger.red('DateSelect:addEventToDate failed', e)
        })

        .finally(() => {
          isCreatingTempEventRef.current = false
        })
    },
    [
      showSyncIfNeeded,
      showCanOperateEventsIfNeeded,
      calendar,
      props.group,
      props.userSettings,
      addTempFcEvent,
      addMappedTempFcEvent
    ]
  )

  const [haveActiveCalendar, setHaveActiveCalendar] = useState(false)
  const [showEventAddingNotPossible, onShowEventAddingNotPossible] =
    useState(false)
  const isCreatingTempEventRef = useRef(false)

  const landlineCheck = useLandlineCheck()

  const emptyDateClick = useCallback(
    async (arg: DateClickInfo) => {
      Logger.blue('FC:EmptyDateClick', arg.date.valueOf(), arg)
      if (isCreatingTempEventRef.current) {
        Logger.orange('EmptyDateClick: create already in progress, skip')
        return
      }
      if (isUserOutOfTierBasedOnLandline(props.account)) {
        landlineCheck.onShowOutOfTierBasedOnLandline(true)
        return
      }
      if (showSyncIfNeeded()) {
        return
      }
      if (LocalStorage.get(LocalStorageKey.IGNORE_EMPTY_CLICK) === '1') {
        LocalStorage.remove(LocalStorageKey.IGNORE_EMPTY_CLICK)
        return
      }
      if (LocalStorage.get(LocalStorageKey.MORE_EVENTS_OPENED) === '1') return

      if (isGroupcalApp()) {
        if (isGuest()) {
          return
        } else if (!haveActiveCalendar || props.groups?.length == 0) {
          onShowEventAddingNotPossible(true)
          return
        }
      }

      function clearScreen() {
        LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
      }

      if (LocalStorage.get(LocalStorageKey.USER_ID)) {
        if (!LocalStorage.get(LocalStorageKey.VISIBLE_EVENT)) {
          if (isOutOfTier) {
            onShowOutOfTierDialog(true)
          } else if (showCanOperateEventsIfNeeded()) {
            // do nothing
          } else if (userRemoved) {
            setShowUserRemovedDialog(true)
          } else if (
            !LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) ||
            LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) === '0'
          ) {
            const allDay = arg.view.type === 'dayGridMonth' ? false : arg.allDay

            // Keep the exact clicked slot time; do not floor backward to the previous hour.
            let start = dayjs(arg.dateStr).second(0).millisecond(0)

            if (arg.view.type === 'dayGridMonth') {
              start = start.set('hour', 12)
            }

            let end = start.add(1, 'hour')

            if (allDay) {
              start = dayjs.utc(arg.dateStr).startOf('day')
              end = dayjs.utc(arg.dateStr).startOf('day')
            }

            if (LocalStorage.get(LocalStorageKey.USER_ID)) {
              isCreatingTempEventRef.current = true
              const tempFcEvent = addTempFcEvent(
                start.unix(),
                end.unix(),
                allDay
              )

              addEventToDate(
                EventProperties.ADD_EVENT_FROM_LONG_TAP,
                props.group?._id,
                start.unix(),
                end.unix(),
                allDay,
                props.userSettings
              )
                .then((created) => {
                  if (created) {
                    const realFcId = getFullCalendarEventId(created)

                    const mappedTemp = addMappedTempFcEvent(
                      created,
                      tempFcEvent
                    )

                    if (mappedTemp) {
                      pendingTempFcEventsRef.current.set(realFcId, mappedTemp)
                    } else if (tempFcEvent) {
                      pendingTempFcEventsRef.current.set(realFcId, {
                        eventApi: tempFcEvent,
                        tempId: String(tempFcEvent.id)
                      })
                    }
                  } else {
                    removeTempFcEventById(tempFcEvent?.id)
                  }
                  ;(calendar.ref as any).current?.getApi().unselect()
                })
                .catch((error) => {
                  if (error instanceof EventError) {
                    if (error.type === EventErrorType.NO_SYNCABLE_CALENDAR) {
                      setUpdateEventError(t('personalNoCalendars'))
                    }
                  }

                  removeTempFcEventById(tempFcEvent?.id)
                  Logger.red('EmptyDateClick:addEventToDate failed', error)
                })
                .finally(() => {
                  isCreatingTempEventRef.current = false
                })
            }
          }
        } else {
          clearScreen()
        }
      }
    },
    [
      props.account,
      props.group,
      props.groups,
      props.userSettings,
      landlineCheck,
      showSyncIfNeeded,
      showCanOperateEventsIfNeeded,
      haveActiveCalendar,
      isOutOfTier,
      userRemoved,
      calendar,
      addTempFcEvent,
      addMappedTempFcEvent
    ]
  )

  const handleAddEvent = useCallback(
    async (startEnd: StartEndEvent) => {
      if (isCreatingTempEventRef.current) {
        Logger.orange('AddEventButton: create already in progress, skip')
        return
      }

      if (isUserOutOfTierBasedOnLandline(props.account)) {
        landlineCheck.onShowOutOfTierBasedOnLandline(true)
        return
      }

      if (showSyncIfNeeded()) {
        return
      }

      if (showCanOperateEventsIfNeeded()) {
        return
      }

      if (LocalStorage.get(LocalStorageKey.VISIBLE_EVENT)) {
        if (isCypress()) {
          LocalStorage.remove(LocalStorageKey.VISIBLE_EVENT)
        } else {
          return
        }
      }

      if (
        isGroupcalApp() &&
        (!haveActiveCalendar || props.groups?.length == 0)
      ) {
        if (isGuest()) {
          return
        } else {
          onShowEventAddingNotPossible(true)
        }
        return
      }

      if (isOutOfTier) {
        onShowOutOfTierDialog(true)
      } else if (userRemoved) {
        showUserRemoved()
      } else {
        calendar.onScrollToTime(
          dayjs(startEnd.start * 1000).tz(getDefaultTimezone())
        )

        const tempFcEvent = addTempFcEvent(startEnd.start, startEnd.end, false)
        isCreatingTempEventRef.current = true
        try {
          await addEventToDate(
            EventProperties.EVENT_FROM_SCREEN,
            props.group?._id,
            startEnd.start,
            startEnd.end,
            false,
            props.userSettings
          )
            .then((created) => {
              if (created) {
                const realFcId = getFullCalendarEventId(created)

                const mappedTemp = addMappedTempFcEvent(created, tempFcEvent)

                if (mappedTemp) {
                  pendingTempFcEventsRef.current.set(realFcId, mappedTemp)
                } else if (tempFcEvent) {
                  pendingTempFcEventsRef.current.set(realFcId, {
                    eventApi: tempFcEvent,
                    tempId: String(tempFcEvent.id)
                  })
                }
              } else {
                removeTempFcEventById(tempFcEvent?.id)
              }
              ;(calendar.ref as any).current?.getApi().unselect()
            })
            .catch((e) => {
              Logger.red('addEventToDate error', e)
              removeTempFcEventById(tempFcEvent?.id)
              if (e instanceof EventError) {
                if (e.type === EventErrorType.NO_SYNCABLE_CALENDAR) {
                  setUpdateEventError(t('personalNoCalendars'))
                }
              }
            })
        } finally {
          isCreatingTempEventRef.current = false
        }
      }
    },
    [
      props.account,
      props.group,
      props.groups,
      props.userSettings,
      landlineCheck,
      showSyncIfNeeded,
      showCanOperateEventsIfNeeded,
      haveActiveCalendar,
      isOutOfTier,
      userRemoved,
      showUserRemoved,
      calendar,
      addTempFcEvent,
      addMappedTempFcEvent
    ]
  )

  useEffect(() => {
    isUserHaveGroupToAddEvents().then((groupId) => {
      if (groupId) {
        setHaveActiveCalendar(true)
      } else {
        setHaveActiveCalendar(false)
      }
    })
  }, [props.groups, props.userSettings?._rev])

  // Memoize expensive calculations
  const initialCalendarView = useMemo(() => {
    return CALENDAR_VIEW[props.defaultView ?? predefinedView ?? calendar.view]
  }, [props.defaultView, predefinedView, calendar.view])

  const calendarEvents = useMemo(() => {
    if (isListOrGalleryView) {
      return []
    }

    return eventsForCalendar?.fcEvents ?? []
  }, [isListOrGalleryView, eventsForCalendar?.fcEvents])

  // When calendarEvents updates with a real event, remove the matching temp FC event
  useEffect(() => {
    if (pendingTempFcEventsRef.current.size === 0) return
    const calendarApi = (calendar.ref as any).current?.getApi()
    if (!calendarApi) return
    pendingTempFcEventsRef.current.forEach((tempEntry, realFcId) => {
      if (calendarApi.getEventById(realFcId)) {
        calendarApi.getEventById(tempEntry.tempId)?.remove()
        eventModelMapRef.current.delete(tempEntry.tempId)
        pendingTempFcEventsRef.current.delete(realFcId)
      }
    })
  }, [calendarEvents, calendar.ref])

  const listViewStyle = useMemo(
    () => ({
      backgroundColor: theme.palette.background.default,
      position: 'absolute' as const,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    }),
    []
  )

  return (
    <Styled.CalendarView>
      <Styled.CalendarViewScrollContainer>
        <Styled.CalendarViewScroll data-calendar={calendar.view}>
          <EventGlobalsProvider
            account={props.account}
            userSettings={props.userSettings}
            groups={props.groups}
          >
            <TfmFullCalendarMemo
              ignoreDim={props.showOnlySelectedGroup}
              userSettings={props.userSettings}
              dateSelect={dateSelect}
              embedMode={props.embedMode}
              account={props.account}
              group={props.group}
              dropCallback={dropCallback}
              resizeCallback={resizeCallback}
              dayNameFormat={props.dayNameFormat}
              initialView={initialCalendarView}
              events={calendarEvents}
              getEventModel={getEventModel}
              calRef={calendar.ref}
              onDatesSet={onDatesSet}
              emptyDateClick={emptyDateClick}
              handleAddEvent={handleAddEvent}
            />

            {calendar.view === CalendarRange.LISTWEEK ||
            calendar.view === CalendarRange.LISTDAY ? (
              <div style={listViewStyle}>
                {eventsForCalendar?.filteredEvents && (
                  <ListView
                    embedMode={props.embedMode}
                    groupId={props.group?._id}
                    userSettings={props.userSettings}
                    dayNameFormat={props.dayNameFormat}
                    handleAddEvent={handleAddEvent}
                    events={eventsForCalendar?.filteredEvents}
                    group={props.group}
                    loadingEvents={false}
                  />
                )}
              </div>
            ) : (
              <></>
            )}

            {calendar.view === CalendarRange.CARDS ? (
              <div style={listViewStyle}>
                {eventsForCalendar?.filteredEvents && (
                  <GalleryView
                    embedMode={props.embedMode}
                    groupId={props.group?._id}
                    userSettings={props.userSettings}
                    account={props.account}
                    events={eventsForCalendar?.filteredEvents}
                    group={props.group}
                    loadingEvents={false}
                    showGroupTag={
                      (isTrulyEmpty(props.group?._id) &&
                        isTrulyEmpty(calendar.groupServerID)) ||
                      (props.groupIds?.length ?? 0) !== 0
                    }
                  />
                )}
              </div>
            ) : (
              <></>
            )}
          </EventGlobalsProvider>
        </Styled.CalendarViewScroll>
      </Styled.CalendarViewScrollContainer>
      {props.readOnly ? (
        <></>
      ) : (
        <AddEventButton
          handleAddEvent={handleAddEvent}
          onShowOutOfTier={onShowOutOfTierDialog}
          showUserBlockedFromAdding={showCanAddEventsDialog}
          userRemoved={userRemoved}
          showUserRemoved={showUserRemoved}
          groupOutOfTier={isOutOfTier}
          {...props}
        />
      )}
      {props.readOnly || props.embedMode ? (
        <></>
      ) : (
        <Box
          id="chatbase-custom-button"
          position={'absolute'}
          bottom={20}
          right={i18n.dir() === 'ltr' ? 16 : undefined}
          left={i18n.dir() === 'ltr' ? undefined : 16}
          zIndex={10001}
        >
          <ChatbaseButton />
        </Box>
      )}
      {userRemoved && showUserRemovedDialog && (
        <ConfirmationDialog
          rightButtonHidden
          title={`${t('youDontHavePermissions')}`}
          content={''}
          leftButton={'OK'}
          leftButtonColor={APP_COLOR}
          handleLeftButton={hideUserRemovedDialog}
          handleClose={hideUserRemovedDialog}
          open={showUserRemovedDialog}
        />
      )}
      {userCannotAddEvents && (
        <ConfirmationDialog
          rightButtonHidden
          title={t('cantDoThat')}
          content={t('onlyCalendarAdmins')}
          leftButton={t('ok')}
          leftButtonColor={APP_COLOR}
          handleLeftButton={hideCanAddEventsDialog}
          handleClose={hideCanAddEventsDialog}
          open={userCannotAddEvents}
        />
      )}
      {showOutOfTierDialog && (
        <OutOfTierDialog
          flow={BlockedFlow.addItem}
          account={props.account}
          group={props.group}
          setOpen={onShowOutOfTierDialog}
          opened={showOutOfTierDialog}
        />
      )}
      {showRecurrenceDialog && (
        <RecurrentActionDialog
          disableOthers
          handleLeftButton={() => {
            Database.write(async () => {
              const old = droppedEventData?.oldEvent as
                | Model<EventDoc>
                | undefined
              if (old && typeof old.update === 'function') {
                old.update((local) => {
                  local.StartDate = `${droppedEventData?.oldStart}`
                  local.EndDate = `${droppedEventData?.oldEnd}`
                  local.AllDay = droppedEventData?.oldAllDay ? '1' : '0'
                  local.TimeZoneNameID = droppedEventData?.oldTimeZone
                })
              }
            })
          }}
          default={RECUR_SAVE_TYPE.ALL}
          open={showRecurrenceDialog}
          handleClose={handleCloseRecurringSave}
          handleSaveRecurringEvent={handleSaveRecurringEvent}
        />
      )}
      {updateEventError && (
        <ConfirmationDialog
          title={`${t('cantDoThat')}`}
          content={updateEventError}
          leftButtonHidden
          rightButton={`${t('ok')}`}
          handleClose={() => {
            setUpdateEventError(undefined)
          }}
          open={updateEventError != undefined}
        />
      )}
      {showEventAddingNotPossible && (
        <ConfirmationDialog
          title={''}
          content={isGuest() ? t('toAddEventsGuest') : t('toAddEvents')}
          leftButtonHidden
          rightButton={`${t('ok')}`}
          rightButtonColor={APP_COLOR}
          handleRightButton={() => {
            onShowEventAddingNotPossible(false)
          }}
          open
          handleClose={() => {
            onShowEventAddingNotPossible(false)
          }}
        />
      )}
      <TierEndDialog account={props.account} />
      {showCalendarSync && (
        <ResyncCalendarDialog
          isOpen={showCalendarSync}
          setOpen={onShowCalendarSync}
          group={props.group}
        />
      )}
    </Styled.CalendarView>
  )
}

export function isEventRecurrenceInTimePeriod(
  event: EventDoc,
  visibleAreaStart: Dayjs,
  visibleAreaEnd: Dayjs
): boolean {
  const rruleString = mapRecurrency(event, true)
  if (!rruleString) return false

  const rrule = rrulestr(rruleString)
  const occurrences = rrule.between(
    visibleAreaStart.toDate(),
    visibleAreaEnd.toDate(),
    true
  )

  return occurrences.length > 0
}

export function isEventWithinTimePeriod(
  event: EventDoc,
  visibleAreaStart: Dayjs,
  visibleAreaEnd: Dayjs
): boolean {
  return isEventInstanceWithinTimePeriod(
    event,
    visibleAreaStart,
    visibleAreaEnd
  )
}

interface TierEndDialogProps {
  account: AccountDoc
}

function TierEndDialog(props: TierEndDialogProps) {
  const payment = usePayment()

  const [trialProduct, onTrialProduct] = useState<AccountProduct | undefined>(
    undefined
  )

  function checkTrialDialog() {
    const trialProduct = exhaustedProduct(props.account)

    if (
      trialProduct &&
      props.account?.Products?.filter((product) => product.Status != 'trialing')
        .length === 0 // meaning we don't have any other products
    ) {
      const delta = dayjs().diff(
        dayjs(Number(trialProduct.ExpiryDate) * 1000),
        'month'
      )

      if (
        delta < 3 &&
        LocalStorage.get(LocalStorageKey.EXPIRY_DIALOG_SHOWN) != null &&
        LocalStorage.get(LocalStorageKey.EXPIRY_DIALOG_SHOWN) != '1'
      ) {
        LocalStorage.set(LocalStorageKey.EXPIRY_DIALOG_SHOWN, '1')
        onTrialProduct(trialProduct)
        onShowDialog(trialProduct != undefined)
      }
    }
  }

  const [showDialog, onShowDialog] = useState(false)
  //each minute check if we have expired product
  useEffect(() => {
    checkTrialDialog()

    const interval = setInterval(() => {
      checkTrialDialog()
    }, 60000)

    return () => clearInterval(interval)
  }, [props.account])

  const closeDialog = () => {
    onShowDialog(false)
  }

  const openPurchase = () => {
    payment.showPaymentDialog(null)
    closeDialog()
  }

  return (
    <>
      {trialProduct && showDialog && (
        <ConfirmationDialog
          title={t('trialExpired')}
          content={t('yourTrialExpirationDate', {
            date: dayjs(Number(trialProduct.ExpiryDate) * 1000)
              .add(10, 'minute')
              .format('dddd, DD MMM YYYY, HH:mm')
          })}
          rightButton={`${t('purchaseAPlan')}`}
          leftButton={`${t('donwgradeToBasic')}`}
          leftButtonColor={'black'}
          rightButtonColor={APP_COLOR}
          handleLeftButton={closeDialog}
          handleRightButton={openPurchase}
          open={showDialog}
          handleClose={() => {}}
        />
      )}
    </>
  )
}

export interface TfmFullCalendarProps {
  dateSelect: ((arg: DateSelectInfo) => void) | undefined
  initialView: string
  height?: number
  emptyDateClick?: (arg: DateClickInfo) => void
  onDatesSet?: (datesSetArg: DatesSetInfo) => void
  events: EventSourceInput
  /** Stable getter — reads from eventModelMapRef at call-time, never changes reference */
  getEventModel?: (id: string) => EventDoc | Model<EventDoc> | undefined
  calRef?: Ref<FullCalendarRef>
  dayNameFormat?: string
  dropCallback: (arg: EventDropInfo) => void
  resizeCallback: (arg: EventResizeDoneInfo) => void
  account: AccountDoc
  group: GroupDoc
  userSettings: UserSettingsDoc
  handleAddEvent: (startEnd: StartEndEvent) => void
  ignoreDim?: boolean
  embedMode?: boolean
}

const EVENT_CONTENT_WRAPPER_STYLE = { height: '100%', width: '100%' }

const EVENT_MODEL_OVERRIDE_KEYS = [
  'OwnerID',
  'GroupID',
  'ThirdPartyID',
  'PersonalOwnerId',
  'Color',
  'TaskType',
  'referenceGroup'
] as const

function applyEventModelOverrides(
  event: EventDoc | undefined,
  fcEvent: any
): EventDoc | undefined {
  if (!event) return event

  const extendedProps = fcEvent?.extendedProps ?? fcEvent?._def?.extendedProps
  if (!extendedProps) return event

  const overrides: Partial<EventDoc> = {}
  let hasOverrides = false

  EVENT_MODEL_OVERRIDE_KEYS.forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(extendedProps, key)) return

    const value = extendedProps[key]
    if ((event as any)[key] === value) return
    ;(overrides as any)[key] = value
    hasOverrides = true
  })

  return hasOverrides ? ({ ...event, ...overrides } as EventDoc) : event
}

const TfmFullCalendarMemo = React.memo(function TfmFullCalendarInner(
  props: TfmFullCalendarProps
) {
  useEffect(() => {
    const divsToAnimate = document.querySelectorAll('.animate-opacity')
    divsToAnimate.forEach((div) => div.classList.add('animate-opacity'))
  }, [])

  const appSettings = useAppSettings()

  const targetDivRef = React.useRef<HTMLDivElement>(null)

  function firstDayForFullCalendar(
    firstDayOfTheWeek: number
  ): number | undefined {
    switch (firstDayOfTheWeek) {
      case FIRST_DAYS.SUNDAY:
        return 0
      case FIRST_DAYS.MONDAY:
        return 1

      default:
        return 0
    }
  }

  const calendar = useCalendar()
  const keepPopupAnchorRef = useRef<HTMLElement | null>(null)
  const initialScrollTime = useMemo(() => dayjs().format('HH:mm:ss'), [])

  const plugins = useMemo(
    () => [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin,
      rrulePlugin,
      listPlugin,
      adaptivePlugin,
      themePlugin
    ],
    []
  )

  const views = useMemo(
    () => ({
      galleryMonth: {
        type: 'dayGrid',
        duration: { months: 1 }
      },
      timeGrid: {
        slotLaneClass: (slotData: any) =>
          slotData.isMinor
            ? 'my-timegrid-slot my-timegrid-slot-minor'
            : 'my-timegrid-slot'
      }
    }),
    []
  )

  const slotDuration = useMemo(() => ({ minutes: 30 }), [])
  const snapDuration = useMemo(() => ({ minutes: 15 }), [])
  const slotHeaderInterval = useMemo(() => ({ hours: 1 }), [])

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [moreEvents, setMoreEvents] = useState<EventSegment[] | undefined>(
    undefined
  )

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  useEffect(() => {
    keepPopupAnchorRef.current = anchorEl
  }, [anchorEl])

  useEffect(() => {
    const handleResize = () => {
      setAnchorEl(null)
      // Add your resize logic here
    }

    window.addEventListener('resize', handleResize)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const { closePopover, pointTo } = useEventPopoverCallbacks()
  const [eventForMenu, setEventForMenu] = useState<EventDoc | null>(null)

  const [contextMenuPosition, setContextMenuPosition] = useState<{
    x: number
    y: number
  } | null>(null)
  const [selectedEventForMenu, setSelectedEventForMenu] = useState<{
    event: EventDoc
    instanceStart: number
    instanceEnd: number
  } | null>(null)

  const handleContextMenu = useCallback(
    (
      event: React.MouseEvent,
      eventDoc: EventDoc,
      instanceStart: number,
      instanceEnd: number
    ) => {
      event.preventDefault()
      setContextMenuPosition({ x: event.clientX, y: event.clientY })
      setSelectedEventForMenu({
        event: eventDoc,
        instanceStart,
        instanceEnd
      })
    },
    []
  )

  const handleCloseContextMenu = useCallback(() => {
    setContextMenuPosition(null)
    setSelectedEventForMenu(null)
    LocalStorage.remove(LocalStorageKey.DRAGGING)
  }, [])

  const eventOrderForView = useMemo(
    () => eventOrder(calendar.view, props.getEventModel),
    [calendar.view, props.getEventModel]
  )

  const handleEventDrop = useCallback(
    (arg: EventDropInfo) => {
      props.dropCallback(arg)
    },
    [props.dropCallback]
  )

  const handleMoreLinkContent = useCallback((e: any) => {
    return <MoreLink num={e.num} />
  }, [])

  const handleMoreLinkClick = useCallback((e: any) => {
    setMoreEvents(e.hiddenSegs)
    setAnchorEl(e.jsEvent.currentTarget as HTMLElement)
  }, [])

  const handleMoreLinkWillUnmount = useCallback(() => {
    setAnchorEl(null)
    setMoreEvents(undefined)
    if (
      keepPopupAnchorRef.current &&
      LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) !== '1'
    ) {
      closePopover()
    }
  }, [closePopover])

  const handleEventDragStart = useCallback(
    (_e: any) => {
      closePopover()
      LocalStorage.set(LocalStorageKey.SHOULD_KEEP_POPUP, '1')
      LocalStorage.set(LocalStorageKey.DRAGGING, '1')
    },
    [closePopover]
  )

  const handleEventDragStop = useCallback(
    (dragStop: any) => {
      LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
      setTimeout(() => {
        LocalStorage.remove(LocalStorageKey.DRAGGING)
      }, 51)

      setTimeout(() => {
        const pendingEventData = props.getEventModel?.(dragStop.event.id) as
          | EventDoc
          | undefined

        if (
          LocalStorage.get(LocalStorageKey.PENDING_EVENT_DATA) !== null ||
          isTrulyEmpty(pendingEventData?._id)
        ) {
          pointTo(
            pendingEventData
              ? document.getElementById(
                  eventIdForContainer(
                    pendingEventData,
                    Number(pendingEventData.StartDate) * 1000
                  ) ?? ''
                )
              : dragStop.el,
            'dragged'
          )
        }
      }, 250)
    },
    [pointTo, props.getEventModel]
  )

  const handleEventResizeStart = useCallback(() => {
    closePopover()
    LocalStorage.set(LocalStorageKey.SHOULD_KEEP_POPUP, '1')
    LocalStorage.set(LocalStorageKey.DRAGGING, '1')
  }, [closePopover])

  const handleEventResizeStop = useCallback((_resizeStop: any) => {
    LocalStorage.remove(LocalStorageKey.SHOULD_KEEP_POPUP)
    setTimeout(() => {
      LocalStorage.remove(LocalStorageKey.DRAGGING)
    }, 51)
  }, [])

  const handleDayHeaderContent = useCallback(
    (e: any) => {
      return (
        <DayHeaderContent
          groupId={props.group?._id}
          userSettings={props.userSettings}
          dayNameFormat={props.dayNameFormat}
          handleAddEvent={props.handleAddEvent}
          {...e}
        />
      )
    },
    [
      props.group?._id,
      props.userSettings,
      props.dayNameFormat,
      props.handleAddEvent
    ]
  )

  const resolveEventModel = useCallback(
    (fcEvent: any): EventDoc | undefined => {
      const byId = props.getEventModel?.(fcEvent.id)
      if (byId) return applyEventModelOverrides(byId as EventDoc, fcEvent)

      const byPublicId = props.getEventModel?.(fcEvent._def?.publicId ?? '')
      if (byPublicId)
        return applyEventModelOverrides(byPublicId as EventDoc, fcEvent)

      const byExtendedProps =
        fcEvent?.extendedProps?.eventModel ??
        fcEvent?._def?.extendedProps?.eventModel

      return applyEventModelOverrides(byExtendedProps as EventDoc, fcEvent)
    },
    [props.getEventModel]
  )

  const handleEventContent = useCallback(
    (e: EventDisplayInfo) => {
      const event = resolveEventModel(e.event)

      const { instanceStart, instanceEnd } = getEventInstanceTimes(
        e.event.startStr,
        e.event.endStr,
        e.event.allDay,
        event
      )
      return (
        <div
          onContextMenu={(mouseEvent) => {
            if (!event || event._id?.length === 0 || isGuest()) return
            handleContextMenu(mouseEvent, event, instanceStart, instanceEnd)
            setEventForMenu(event)
          }}
          id={`${e.event.id}_${dayjs(e.event.start ?? Date()).format(
            'YYYY-MM-DD'
          )}`}
          onClick={() => {
            handleCloseContextMenu()
          }}
          ref={event && event._id?.length === 0 ? targetDivRef : undefined}
          style={EVENT_CONTENT_WRAPPER_STYLE}
        >
          <EventContent
            ignoreDim={
              (props.ignoreDim && !props.embedMode) ||
              !event ||
              (isTrulyEmpty(event._rev) && isTrulyEmpty(event.Text))
            }
            closeAll={false}
            embedMode={props.embedMode}
            eventModel={event}
            instanceStart={instanceStart}
            instanceEnd={instanceEnd}
            {...e}
          />
        </div>
      )
    },
    [
      resolveEventModel,
      handleContextMenu,
      handleCloseContextMenu,
      props.ignoreDim,
      props.embedMode
    ]
  )

  return (
    <>
      {contextMenuPosition && (
        <EventContextMenu
          x={contextMenuPosition.x}
          y={contextMenuPosition.y}
          onClose={handleCloseContextMenu}
          event={eventForMenu}
          group={props.group}
          instanceStart={selectedEventForMenu?.instanceStart ?? 0}
          instanceEnd={selectedEventForMenu?.instanceEnd ?? 0}
        />
      )}
      {anchorEl && (
        <TFloatingPopover
          id={id ?? ''}
          open={open}
          defaultPlacement="right"
          fallbackPlacements={['left']}
          anchorElement={anchorEl}
          closeOnTouchOutside={false}
          onOutsideClick={() => {
            if (LocalStorage.get(LocalStorageKey.VISIBLE_EVENT) === null) {
              setAnchorEl(null)
              closePopover()
            }
          }}
          onClose={handlePopoverClose}
          content={
            <EventsListPopupContent
              events={moreEvents ?? []}
              eventDrawer={(eventSegment) => {
                const segmentEvent = resolveEventModel(eventSegment.event)
                if (!segmentEvent) return null

                const { instanceStart, instanceEnd } = getEventInstanceTimes(
                  eventSegment.event.startStr,
                  eventSegment.event.endStr,
                  eventSegment.event.allDay,
                  segmentEvent
                )
                return (
                  <Box
                    sx={{
                      marginRight: () => {
                        if (
                          eventLengthInDays(segmentEvent) > 1 &&
                          !eventSegment.isEnd &&
                          !eventSegment.isStart
                        )
                          return '0.2rem'
                        else if (
                          eventLengthInDays(segmentEvent) > 1 &&
                          eventSegment.isStart
                        )
                          return '0.2rem'
                        else return '1rem'
                      },
                      marginLeft: () => {
                        if (
                          eventLengthInDays(segmentEvent) > 1 &&
                          !eventSegment.isEnd &&
                          !eventSegment.isStart
                        )
                          return '0.2rem'
                        else if (
                          eventLengthInDays(segmentEvent) > 1 &&
                          eventSegment.isEnd
                        )
                          return '0.2rem'
                        else return '1rem'
                      }
                    }}
                  >
                    <Event
                      embedMode={props.embedMode}
                      dynamicDesign
                      isEnd={eventSegment.isEnd}
                      alwaysFullSize={false}
                      ignoreDim={props.ignoreDim}
                      onEventDetailsClose={() => {}}
                      isStart={eventSegment.isStart}
                      instanceStart={instanceStart}
                      instanceEnd={instanceEnd}
                      event={segmentEvent}
                      title={segmentEvent.Text ?? ''}
                    />
                  </Box>
                )
              }}
            />
          }
        />
      )}
      <div className="tfm-calendar-root" style={{ height: '100%' }}>
        <FullCalendar
          plugins={plugins}
          views={views}
          eventPrintLayout="stack"
          fixedWeekCount={false}
          schedulerLicenseKey={process.env.REACT_APP_FC_KEY}
          timeZone={appSettings.timeZone}
          initialView={props.initialView}
          firstDay={firstDayForFullCalendar(appSettings.firstDayOfTheWeek)}
          height={'100%'}
          expandRows={false}
          dayMaxEvents
          scrollTimeReset={false}
          slotDuration={slotDuration}
          snapDuration={snapDuration}
          slotHeaderInterval={slotHeaderInterval}
          headerToolbar={false}
          scrollTime={initialScrollTime}
          eventStartEditable
          eventResizableFromStart
          editable={
            !isGuest() &&
            (isTrulyEmpty(LocalStorage.get(LocalStorageKey.SELECTED_GROUP)) ||
              isGroupNotAvailableForEventChanges(props.group, props.account) ===
                false)
          }
          droppable={
            !isGuest() &&
            (isTrulyEmpty(LocalStorage.get(LocalStorageKey.SELECTED_GROUP)) ||
              isGroupNotAvailableForEventChanges(props.group, props.account) ===
                false)
          }
          selectable={
            !isGuest() &&
            (isTrulyEmpty(LocalStorage.get(LocalStorageKey.SELECTED_GROUP)) ||
              isGroupNotAvailableForEventChanges(props.group, props.account) ===
                false)
          }
          eventDrop={handleEventDrop}
          select={props.dateSelect}
          eventResize={props.resizeCallback}
          dateClick={props.emptyDateClick}
          moreLinkContent={handleMoreLinkContent}
          moreLinkClick={handleMoreLinkClick}
          moreLinkWillUnmount={handleMoreLinkWillUnmount}
          eventDragStart={handleEventDragStart}
          eventDragStop={handleEventDragStop}
          eventResizeStart={handleEventResizeStart}
          eventResizeStop={handleEventResizeStop}
          direction={i18n.dir()}
          nowIndicator
          datesSet={props.onDatesSet}
          unselectAuto
          selectMinDistance={5}
          dayHeaderContent={handleDayHeaderContent}
          eventOrder={eventOrderForView}
          eventContent={handleEventContent}
          selectMirror={true}
          slotMinHeight={25}
          popoverClass={'my-popover'}
          listItemEventBeforeClass={'my-list-item-event-dot'}
          allDayHeaderContent={AllDayContent}
          slotHeaderContent={SlotLabelContent}
          dayCellTopContent={DayCellContent}
          slotHeaderClass={'my-slot-header'}
          dayHeaderClass={dayHeaderClass}
          dayHeaderDividerClass="calendar-day-header-divider"
          highlightClass={'my-date-selection-highlight'}
          moreLinkText={'more'}
          moreLinkClass={'my-more'}
          eventColor={'transparent'}
          eventClass={'my-event'}
          events={props.events}
          ref={props.calRef}
        />
      </div>
    </>
  )
})

function eventOrder(
  _view: CalendarRange,
  getEventModel?: (id: string) => EventDoc | Model<EventDoc> | undefined
) {
  return (a: any, b: any) => {
    const groupcalA = getEventModel?.(a.id) as EventDoc | undefined
    const groupcalB = getEventModel?.(b.id) as EventDoc | undefined
    const startA = a.start
    const startB = b.start
    const typeA = groupcalA?.Type ?? DocType.EVENT
    const typeB = groupcalB?.Type ?? DocType.EVENT

    const allDayA = groupcalA?.AllDay === '1'
    const allDayB = groupcalB?.AllDay === '1'

    const selectedGroup: string | null = LocalStorage.get(
      LocalStorageKey.SELECTED_GROUP
    )

    // Check if events are from the selected group
    const groupASelected = selectedGroup && groupcalA?.GroupID === selectedGroup
    const groupBSelected = selectedGroup && groupcalB?.GroupID === selectedGroup

    // non task types should be on top
    if (typeA !== DocType.TASK && typeB === DocType.TASK) {
      return -1
    } else if (typeA === DocType.TASK && typeB !== DocType.TASK) {
      return 1
    }

    if (isTrulyEmpty(groupcalA?._id)) {
      return -1
    }

    if (groupASelected && !groupBSelected) {
      return -1
    } else if (!groupASelected && groupBSelected) {
      return 1
    }

    // Prioritize all-day events
    if (allDayA && !allDayB) {
      return -1
    } else if (!allDayA && allDayB) {
      return 1
    }

    // Sort by start time in descending order
    if (startA > startB) {
      return 1
    } else if (startA < startB) {
      return -1
    }

    return 0
  }
}

let addEventToDateInFlight = false

export async function addEventToDate(
  source: string,
  groupId: string | undefined,
  startTime: number,
  endTime: number,
  allDay: boolean,
  userSettings?: UserSettingsDoc
) {
  if (LocalStorage.get(LocalStorageKey.VISIBLE_EVENT) !== null) return
  if (addEventToDateInFlight) {
    Logger.orange('addEventToDate: already in flight, skip')
    return
  }

  addEventToDateInFlight = true
  try {
    const veryFirstGroup = await provideFirstGroup()
    let group: Model<GroupDoc> | GroupDoc | undefined = await localGroupById(
      groupId ?? ''
    )

    Analytics.getInstance().sendEvent(Events.EVENT_START_ADD_EVENT, {
      [EventProperties.LOCATION_ADD_EVENT]: source
    })

    let groupIdForEvent: string | undefined =
      group?._id ?? defaultGroupId(userSettings) ?? veryFirstGroup?._id

    if (groupIdForEvent === '' || !groupIdForEvent) {
      groupIdForEvent = defaultGroupId(userSettings) ?? veryFirstGroup?._id
    }

    const generalGroupId: string | undefined =
      await isUserHaveGroupToAddEvents()
    Logger.orange(
      'Adding event to group',
      group,
      groupIdForEvent,
      groupId,
      generalGroupId
    )
    if (isTrulyEmpty(generalGroupId) && isGroupcalApp()) {
      return
    }

    if (!group || (is24meApp() && !groupId)) {
      group = await localGroupById(groupIdForEvent ?? '')
      if (group && group.SyncProblem === '1') {
        group = undefined
      }
    }

    let thirdPartyId: string | undefined = groupToThirdPartyCalendarId(group)
    const groupsSettings = userSettings?.GroupsSettings[groupIdForEvent ?? '']

    if (
      groupsSettings?.ConvertedCalendars?.find((cal) => cal.id === thirdPartyId)
        ?.syncable === false
    ) {
      // primary calendar is not syncable, we need to pick another which has syncable true or undefined
      thirdPartyId = userSettings?.GroupsSettings[
        groupIdForEvent ?? ''
      ]?.ConvertedCalendars?.find(
        (cal) =>
          (cal.syncable !== false || cal.syncable === undefined) &&
          cal.canEdit === true
      )?.id

      // in case we trying to add an event to a non syncable calendar and we don't have another calendar to add to, we should not add the event
      if (!thirdPartyId) {
        Logger.red('No syncable calendar found for group', groupIdForEvent)
        throw new EventError(
          EventErrorType.NO_SYNCABLE_CALENDAR,
          'No syncable calendar found for group'
        )
      }
    }
    const created = await addTempEventToDate(
      startTime,
      endTime,
      groupIdForEvent,
      allDay,
      is24meApp()
        ? groupId || group
          ? DocType.EVENT
          : DocType.TASK
        : DocType.EVENT,
      undefined,
      thirdPartyId,
      undefined,
      isConvertedGroup(group) ? TaskType.personalEvent : TaskType.meet
    ).then((tempEvent) => {
      return tempEvent
    })

    return created
  } finally {
    addEventToDateInFlight = false
  }
}

interface AddEventButtonProps extends CalendarViewProps {
  showUserRemoved: () => void
  userRemoved: boolean
  showUserBlockedFromAdding: () => void
  onShowOutOfTier: (b: boolean) => void
  groupOutOfTier: boolean
  handleAddEvent: (startEnd: StartEndEvent) => void
}

function AddEventButton(props: AddEventButtonProps) {
  return (
    <>
      <Styled.AddEventButton
        id="add-event-button"
        onClick={() => {
          const startEnd = generateStartEndBasedOnTimeWithShift(
            Number(LocalStorage.get(LocalStorageKey.VISIBLE_DATE)) / 1000
          )

          props.handleAddEvent(startEnd)
        }}
      >
        <AddIcon />
        <span>{t('event')}</span>
      </Styled.AddEventButton>
    </>
  )
}

export function ChatbaseButton() {
  const chatbase = useChatbase()

  useEffect(() => {
    Logger.blue('Chatbase: isChatOpen changed', chatbase.isChatOpen)
  }, [chatbase.isChatOpen])

  if (is24meApp()) return <></>

  return (
    <Tooltip enterDelay={600} title={t('supportChat')} placement="top">
      <Box
        onClick={() => {
          if (chatbase.isChatOpen) {
            chatbase.closeChat()
          } else {
            chatbase.openChat()
          }
        }}
        sx={{
          zIndex: 1001,
          fontSize: '20px',
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'background-color 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          }
        }}
      >
        {chatbase.isChatOpen ? (
          <Box
            component="span"
            sx={{
              color: 'white',
              fontSize: 'inherit',
              fontWeight: 'bold',
              lineHeight: 1
            }}
          >
            ✕
          </Box>
        ) : (
          <Box
            component="span"
            sx={{
              color: 'white',
              fontSize: 'inherit',
              fontWeight: 'bold',
              lineHeight: 1
            }}
          >
            ?
          </Box>
        )}
      </Box>
    </Tooltip>
  )
}

const CalendarViewWithEvents = withObservables(
  ['groupID', 'userSettings'],
  (props: CalendarViewProps) => ({ events: ObserveService.Events(undefined) })
)(CalendarView as any)

const CalendarViewWithGroups = withObservables(
  [],
  (props: CalendarViewProps) => ({
    groups: ObserveService.Groups()
  })
)(CalendarViewWithEvents as any)

const CalendarViewWithGroup = withObservables(
  ['groupID'],
  (props: CalendarViewProps) => ({
    group: ObserveService.GroupByServerIDRestricted(props.groupID)
  })
)(CalendarViewWithGroups as any)

const CalendarViewWithFirstGroup = withObservables(
  [],
  (props: CalendarViewProps) => ({
    firstGroup: ObserveService.FirstGroup(props.userSettings)
  })
)(CalendarViewWithGroup as any)

const CalendarViewWithUserSettings = withObservables([], () => ({
  userSettings: ObserveService.UserSettings()
}))(CalendarViewWithFirstGroup as any)

export default withObservables([], () => ({
  account: ObserveService.Account()
}))(CalendarViewWithUserSettings as any) as any

interface MoreLinkProps {
  num: number
}

const MoreLink = (props: MoreLinkProps) => {
  return (
    <Box display={'flex'} flexDirection={'column'}>
      {t('moreAmount', { more: props.num })}
    </Box>
  )
}

export function groupToThirdPartyCalendarId(group?: GroupDoc) {
  let thirdPartyId: string | undefined = undefined
  if (!group) return undefined

  if (isConvertedGroup(group)) {
    const provider = groupToProvider(group)

    if (provider === ProviderType.GOOGLE) {
      thirdPartyId = CurrentConvertedCalendars.find(
        (calendar) =>
          calendar.prefix === prefixGoogleEventsGroup &&
          calendar.primaryCalendarEmail ===
            removePrefix(group.CalendarEmail ?? '')
      )?.primaryCalendarEmail
    } else if (provider === ProviderType.OUTLOOK) {
      thirdPartyId = CurrentConvertedCalendars.find(
        (calendar) => calendar.prefix === outlookPrefix && calendar.primary
      )?.id
    } else if (provider === ProviderType.APPLE) {
      thirdPartyId = CurrentConvertedCalendars.find(
        (calendar) => calendar.prefix === icloudPrefix && calendar.primary
      )?.id
    }
  }

  return thirdPartyId
}
